import { createSlice } from "@reduxjs/toolkit";

// Slice to store the list of roles within a project
const roleDataSlice = createSlice({
  name: "roleData",
  initialState: [],
  reducers: {
    setProjectRolesList: (_state, action) => action.payload,
  },
});
export const { setProjectRolesList } = roleDataSlice.actions;
export const roleData = roleDataSlice.reducer;

// Slice to store list of users inside spaces
const spacesUsersDataSlice = createSlice({
  name: "spacesUsersData",
  initialState: [],
  reducers: {
    setSpacesInProjectList: (_state, action) => action.payload,
  },
});
export const { setSpacesInProjectList } = spacesUsersDataSlice.actions;
export const spacesUsersData = spacesUsersDataSlice.reducer;

// Slice to store project entities list
const entityListSlice = createSlice({
  name: "entityList",
  initialState: [],
  reducers: {
    setEntityList: (_state, action) => action.payload,
  },
});
export const { setEntityList: setEntityListAction } = entityListSlice.actions;
export const setEntityList = entityListSlice.reducer;

// Slice to store status list
const statusDataSlice = createSlice({
  name: "statusData",
  initialState: [],
  reducers: {
    setStatusData: (_state, action) => action.payload,
  },
});
export const { setStatusData } = statusDataSlice.actions;
export const statusData = statusDataSlice.reducer;

// Slice to store category list
const categoryListSlice = createSlice({
  name: "categoryList",
  initialState: [],
  reducers: {
    setCategoryList: (_state, action) => action.payload,
  },
});
export const { setCategoryList: setCategoryListAction } = categoryListSlice.actions;
export const setCategoryList = categoryListSlice.reducer;

// Slice for deleted space status
const deleteSpaceSlice = createSlice({
  name: "deleteSpace",
  initialState: [],
  reducers: {
    deletedSpaceStatus: (_state, action) => action.payload,
  },
});
export const { deletedSpaceStatus } = deleteSpaceSlice.actions;
export const deleteSpace = deleteSpaceSlice.reducer;

// Slice for deleted user status
const deletedUserSlice = createSlice({
  name: "DeletedUserState",
  initialState: [],
  reducers: {
    deletedUserStatus: (_state, action) => action.payload,
  },
});
export const { deletedUserStatus } = deletedUserSlice.actions;
export const DeletedUserState = deletedUserSlice.reducer;

// Slice for project setting object
const projectSettingObjectSlice = createSlice({
  name: "getProjectSettingObject",
  initialState: {},
  reducers: {
    getProjectSettingObject: (_state, action) => action.payload,
  },
});
export const { getProjectSettingObject: getProjectSettingObjectAction } = projectSettingObjectSlice.actions;
export const getProjectSettingObject = projectSettingObjectSlice.reducer;
